const { log } = require("./commons");
const {
  utils: {
    commons: { getFeatureFlagValue }
  }
} = require("@gwp/oicms-rendering-utils");

/**
 * Get feature flag from site-config or local-config
 * @param {*} flagKey
 * @returns boolean flag test result
 */
const getFeatureFlag = (flagKey) => {
  return getFeatureFlagValue({
    flagKey,
    appFeatureFlags: global.appFeatureFlags,
    log
  });
};

const getCommonConstantsValue = (key) => {
  const { app_common_constants, constants } = global.appCommonConstants || {};
  return app_common_constants?.[key] || constants?.[key];
};

module.exports = {
  getFeatureFlag,
  getCommonConstantsValue
};
